module.exports = __webpack_public_path__ + "img/shogi_2021_pack_4_0005.6afe4935.png";